<div class="app-container">
  <page-header [icon]="'far-chart-pie'" [title]="'stats.title'">
    <ng-container class="header-button"> </ng-container>
  </page-header>

  <section class="content">
    <app-filter-form
      [filters]="queryFilters"
      [isFilterInvisible]="true"
      [areExportsInFilter]="false"
      [isExportButtonShown]="false"
      [entity]="'productMoves'"
      (onSubmit)="filter()"
      (onClearClick)="clearFilters()"
    >
      <div class="row">
        <div class="col-12 col-sm-4 col-md-4 col-lg-2">
          <form-row-input
            [label]="'date.from'"
            [icon]="null"
            [inputType]="'date'"
            [(model)]="filters.dateFrom"
            (onKeyPress)="onFilterFormKeyPress($event)"
          ></form-row-input>
        </div>
        <div class="col-12 col-sm-4 col-md-4 col-lg-2 col-xl-2">
          <form-row-input
            [label]="'date.to'"
            [icon]="null"
            [inputType]="'date'"
            [(model)]="filters.dateTo"
            (onKeyPress)="onFilterFormKeyPress($event)"
          ></form-row-input>
        </div>
        <div class="col-12 col-sm-4 col-md-4 col-lg-2">
          <form-row-select-multiple
            [label]="'products.checkouts'"
            [options]="checkouts"
            [(selectedValues)]="filters.checkouts"
          ></form-row-select-multiple>
        </div>
        <div class="col-12 col-sm-2 col-md-2 col-lg-2">
          <app-modal-category-search
            [isForFilterCategories]="true"
            [selectedCategories]="filters.categories"
            (selectedCategoriesChange)="filterCategoriesChanged($event)"
          >
          </app-modal-category-search>
        </div>
        <div class="col-12 col-sm-2 col-lg-3" [ngStyle]="{ marginTop: '21px' }">
          <form-row-toggle [label]="'stats.pricesWithVat'" [(model)]="isPricesWithVat"></form-row-toggle>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <modal-product-search-stats (onProductSelect)="toggleProductInFilters($event)"></modal-product-search-stats>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="badge-list">
            <div class="badge badge-primary" *ngFor="let p of filters.products">
              <span class="truncate" data-toggle="tooltip" title="{{ p.fullName }}">{{ p.fullName }}</span>
              <span
                (click)="toggleProductInFilters(p)"
                (keyup)="toggleProductInFilters(p)"
                tabindex="-1"
                class="delete ml-1"
              >
                <i class="far fa-times" data-cy="empty"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </app-filter-form>
  </section>
  <section class="mb-4" *ngIf="loading">
    <progressbar type="danger" [value]="currentPageProgress" [striped]="true" [max]="endPage"></progressbar>
  </section>
  <section>
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="card info-card w-100 d-flex flex-column align-items-center">
              <loading-spinner
                [isLoading]="loading"
                [isBackdropOpaque]="true"
                [classesString]="'top-50'"
              ></loading-spinner>
              <div class="big-num">
                {{ valueSum | formatPrice: purchaseCurrencyFromCompany }}
              </div>
              <div class="font-weight-bold">{{ 'stats.valueSum' | translate }}</div>
              <div class="font-weight-light">{{ 'stats.forGivenTimespan' | translate }}</div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="card info-card w-100 d-flex flex-column align-items-center">
              <loading-spinner
                [isLoading]="loading"
                [isBackdropOpaque]="true"
                [classesString]="'top-50'"
              ></loading-spinner>
              <div class="big-num">{{ batchCount }}</div>
              <div class="font-weight-bold">{{ 'stats.batchCount' | translate }}</div>
              <div class="font-weight-light">{{ 'stats.forGivenTimespan' | translate }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="card info-card w-100">
          <div class="font-weight-bold fz-18 mb-2">
            {{ 'stats.consumptionByTime' | translate }}
          </div>
          <div class="row mt-2">
            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-2">
              <form-row-select
                [options]="chartTimeOptions"
                [model]="chartTime"
                (modelChange)="setChartOptions('chart.time', $event)"
              ></form-row-select>
            </div>
            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-2">
              <form-row-select
                [options]="chartValueOptions"
                [model]="chartValue"
                (modelChange)="setChartOptions('chart.value', $event)"
              ></form-row-select>
            </div>
            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-2">
              <form-row-toggle
                [label]="'stats.chart.isMergingCheckouts'"
                [(model)]="chartIsMergingCheckouts"
              ></form-row-toggle>
            </div>
          </div>
          <div class="row">
            <app-chart
              class="w-100"
              [type]="chartIsMergingCheckouts ? 'mergedCheckout' : 'separateCheckouts'"
              [productMoves]="chartData"
              [chartTime]="chartTime"
              [chartValue]="chartValue"
              [isPricesWithVat]="isPricesWithVat"
              [isLoading]="loading"
            ></app-chart>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pr-0">
        <div class="card info-card w-100">
          <div class="font-weight-bold fz-18 mb-2">
            {{ 'stats.chart.usedProducts' | translate }}
          </div>
          <div class="row mt-2">
            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pr-0">
              <form-row-toggle
                [label]="'stats.chart.isExpandedByBatches'"
                [(model)]="isExpandedByBatches"
                (modelChange)="processData()"
              ></form-row-toggle>
            </div>
          </div>
          <div class="row mt-2">
            <loading-spinner [isLoading]="loading" [classesString]="'top-50'"></loading-spinner>
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pr-0">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th
                        class="w-40 font-weight-bolder cursor-pointer"
                        (click)="sortTable('fullName')"
                        (keyup)="sortTable('fullName')"
                        tabindex="-1"
                      >
                        {{ 'stats.col.product' | translate }}
                        <i
                          *ngIf="tableSortProp === 'fullName'"
                          class="fa"
                          [ngClass]="{
                            'fa-caret-up': tableSortDir === 'desc',
                            'fa-caret-down': tableSortDir === 'asc',
                          }"
                        ></i>
                      </th>
                      <th
                        class="w-20 font-weight-bolder cursor-pointer"
                        (click)="sortTable('batch')"
                        *ngIf="isExpandedByBatches"
                        (keyup)="sortTable('batch')"
                        tabindex="-1"
                      >
                        {{ 'stats.col.batch' | translate }}
                        <i
                          *ngIf="tableSortProp === 'batch'"
                          class="fa"
                          [ngClass]="{
                            'fa-caret-up': tableSortDir === 'desc',
                            'fa-caret-down': tableSortDir === 'asc',
                          }"
                        ></i>
                      </th>
                      <th
                        class="w-20 text-center font-weight-bolder cursor-pointer"
                        (click)="sortTable('quantitySum')"
                        (keyup)="sortTable('quantitySum')"
                        tabindex="-1"
                      >
                        {{ 'stats.col.amountSum' | translate }}
                        <i
                          *ngIf="tableSortProp === 'quantitySum'"
                          class="fa"
                          [ngClass]="{
                            'fa-caret-up': tableSortDir === 'desc',
                            'fa-caret-down': tableSortDir === 'asc',
                          }"
                        ></i>
                      </th>
                      <th
                        class="w-20 text-right font-weight-bolder cursor-pointer"
                        (click)="sortTable('valueSum')"
                        (keyup)="sortTable('valueSum')"
                        tabindex="-1"
                      >
                        {{ 'stats.col.valueSum' | translate }}
                        <i
                          *ngIf="tableSortProp === 'valueSum'"
                          class="fa"
                          [ngClass]="{
                            'fa-caret-up': tableSortDir === 'desc',
                            'fa-caret-down': tableSortDir === 'asc',
                          }"
                        ></i>
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr *ngFor="let pListItem of productListItems" class="images" photoGalleryGroup>
                      <td class="w-40 text-nowrap overflow-hidden">
                        <div class="d-flex flex-row align-items-center">
                          <div
                            [photoGallery]="getThumbUrl(pListItem.product.mainImage, 'w2048wp')"
                            [photoGalleryCaption]="
                              pListItem.product.fullName +
                              '<br>' +
                              (pListItem.product.code ? ('product.code' | translate) + pListItem.product.code : '') +
                              '<br>' +
                              (pListItem.product.ean ? ' EAN: ' + pListItem.product.ean : '')
                            "
                          >
                            <div class="images-item">
                              <img
                                class="images-item-image"
                                [src]="getThumbUrl(pListItem.product.mainImage)"
                                [alt]="pListItem.product.fullName"
                              />
                            </div>
                          </div>
                          <div class="ml-2 product-name">
                            <a [routerLink]="['/product', pListItem.product.id]">{{ pListItem.fullName }}</a>
                          </div>
                        </div>
                      </td>
                      <td class="w-20 text-nowrap" *ngIf="isExpandedByBatches">{{ pListItem.batch }}</td>
                      <td class="w-20 text-center">{{ pListItem.quantitySum }}</td>
                      <td class="w-20 text-right">
                        {{ pListItem.valueSum | formatPrice: purchaseCurrencyFromCompany }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
